<template>
  <f7-page>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div v-if="loaded" class="main-offer-card">
      <div class="summary-header">
        <div class="summary-title">
          <div class="summary-icon-sample-details"></div>
          <div class="summary-text">{{ $t('sample_detail') }}</div>
        </div>

        <div class="summary-actions">
          <button
            class="download-button"
            :disabled="currentSampleSummary.status_code !== '3'"
            @click="$refs.sampleSummary.download()"
          >
            {{ $t('download') }}
          </button>
        </div>
      </div>
      <div v-if="!isFinished" class="warning-message">
        {{ $t('provisionalResultsMessage') }}
      </div>

      <HealthSecuritySamplesSummary ref="sampleSummary" />

      <br />
      <HealthSecuritySamplesDetailTable
        v-if="showDetails"
        class="custom-table-container-health tableContainer"
        :store="customStore"
      />

      <NotificationSpinner
        v-if="!showDetails"
        :message="$t('pendingPaymentSampleResult')"
        :alert="true"
      />

      <!-- <NotificationSpinner
        v-if="inProcess"
        :message="$t('inProcessSampleResult')"
        :warning="true"
      /> -->

      <!-- <GoBack
        class="margin-top"
        :url-name="urlName"
        :go-to-url-name="true"
      /> -->
    </div>
  </f7-page>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import HealthSecuritySamplesDetailTable from '@/components/HealthAndSecurity/SamplesDetails/Table/index.vue';
import HealthSecuritySamplesSummary from '@/components/HealthAndSecurity/SamplesDetails/Summary/index.vue';
// import GoBack from '@/components/UtilityComponents/GoBack/index.vue';
import EventBus from '@/services/event-bus';
import NotificationSpinner from '@/components/NotificationSpinner/index.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'HealthSecuritySamplesDetailsPage',
  components: {
    // GoBack,
    HealthSecuritySamplesDetailTable,
    HealthSecuritySamplesSummary,
    NotificationSpinner,
  },
  data() {
    return {
      loaded: false,
      customStore: null,
      currentSampleSummary: {},
    };
  },
  computed: {
    urlName() {
      // Si accede al detalle de una muestra desde una factura, vuelve al listado de facturas
      if (this.lastRouteIssuedInvoicesList) {
        return 'issuedInvoicesList';
      }
      return this.lastRouteHome
        ? 'Home'
        : 'HealthAndSecuritySamplesPage';
    },
    showDetails() {
      return this.currentSampleSummary?.status_code !== '5';
    },
    inProcess() {
      return this.currentSampleSummary?.status_code === '2';
    },
    isFinished() {
      return this.currentSampleSummary?.status_code === '3';
    },
    ...mapState('filter', ['currentSampleId']),
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteIssuedInvoicesList',
    ]),
  },
  async beforeMount() {
    try {
      this.loaded = false;
      this.currentSampleSummary =
        await this.getCurrentSampleBasedOnFilter();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }
  },
  async mounted() {
    try {
      this.loaded = false;

      EventBus.$on(
        'healthSecurityDetailsFilteredSamples',
        async ({ id, params }) => {
          if (params) {
            this.customStore = await this.getStoreDetailsWithFilters({
              id,
              paramFilters: params,
            });
          } else {
            this.customStore = await this.getDetailsStore();
          }
        }
      );

      this.customStore = await this.getDetailsStore();
    } catch (error) {
      this.customStore = null;
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }

    // if (!this.showDetails) {
    //   this.$notifyDX(
    //     {
    //       message: this.$t('pendingPaymentSampleResult'),
    //       width: 550,
    //     },
    //     'warning',
    //     7000
    //   );
    // }
  },
  methods: {
    ...mapActions('healthSecuritySamples', [
      'getDetailsStore',
      'getStoreDetailsWithFilters',
    ]),
    ...mapActions('filter', ['setCurrentFilter']),
    ...mapActions('samples', ['getCurrentSampleBasedOnFilter']),
  },
};
</script>
<style>
.main-offer-card {
  background-color: white; /* fondo gris suave */
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(87, 84, 95, 0.3);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: clip;
}
.summary-title {
  gap: 10px;
  margin-bottom: 16px;
}

.summary-icon-sample-details {
  width: 24px;
  height: 24px;
  background-image: url('@/static/icons/ic_detalle_muestra.svg');
}

.summary-text {
  font-size: 18px;
  font-weight: 600;
  color: #00346a; /* o el color que uses para encabezados */
}

/* .custom-table-container {
  box-shadow: none !important;
  width: 100% !important;
  max-width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  box-sizing: border-box;
} */

/* Cuando el panel lateral está cerrado */
body:not(.panel-left-reveal) .main-offer-card {
  max-width: 100%; /* o 98% si quieres dejar un margen */
}
</style>
